import { render, staticRenderFns } from "./OtifTargetSettings.vue?vue&type=template&id=38ee4b87&scoped=true&"
import script from "./OtifTargetSettings.vue?vue&type=script&lang=js&"
export * from "./OtifTargetSettings.vue?vue&type=script&lang=js&"
import style0 from "./OtifTargetSettings.vue?vue&type=style&index=0&id=38ee4b87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee4b87",
  null
  
)

export default component.exports